import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
// Import JSX Modules
import ProgressButton from '../_utils/progress-button';
import PickupLocation from '../_utils/pickup-location';
// Import Mixins
import StoreLocatorCommon from '../_libs/store-locator-common';
// Import JS Modules
import translate      from '../_utils/tools/translate';
import columnise      from '../_utils/columnise';
import Store          from '../_utils/tools/store';

// -----------------------------------------------------------
//  StoreLocator
// -----------------------------------------------------------
const StoreLocator = createReactClass({
  mixins: [StoreLocatorCommon],

  componentDidMount() {
    this.search();
  },
  render() {
    return <div>
              { renderLocations.call(this) }
              <small className={ classNames({'lower-space': true, 'd-none': !this.state.errorMessage}) }>
                { this.state.errorMessage }
              </small>
              <form onSubmit={ this.submitSearchForm }>
                <div className="form-group">
                  <label htmlFor={ 'zip-code' + (this.props.serviceFilter || '') }>
                    { this.state.zipCode ? 'You searched' : `Find your nearest ${Store.name} store` }
                  </label>
                  <div className="row">
                    <div className="col-9">
                      <input type="text"
                             className="form-control"
                             placeholder={ translate('Zip Code') }
                             defaultValue={ this.state.zipCode }
                             ref="zip-code"
                             id={ 'zip-code' + (this.props.serviceFilter || '') } />
                    </div>
                    <div className="col-3">
                      <ProgressButton className="btn btn-block btn-primary"
                                      ref="btn-find"
                                      onClick={ this.submitSearchForm } >
                        Find
                      </ProgressButton>
                    </div>
                  </div>
                </div>
              </form>
           </div>;

    function renderLocations() {
      if (this.state.locations.length) {
        return <div className="lower-space">
                 <p><strong>Showing { translate('pick-up') } locations near { this.state.zipCode }</strong></p>
                 {
                   columnise(this.state.locations, 2).map((row, iRow) => {
                     return <div className="row lower-space" key={ iRow }>
                              {
                                row.map((location, iCol) => {
                                  return <div className="col-6" key={ iCol }>
                                           <PickupLocation location={ location } />
                                         </div>;
                                })
                              }
                            </div>;
                   })
                 }
                 <small dangerouslySetInnerHTML={ {__html: this.props.exactNote} } />
               </div>;
      }
    }
  }
});


export default StoreLocator;
